import React from 'react';
import { ReactComponent as CircleLogo } from '../../assets/images/logos/circle.svg';

interface LogoProps {
  size?: number;
  className?: string;
}

const Logo: React.FC<LogoProps> = ({ size = 24, className = '' }) => {
  return (
    <CircleLogo 
      width={size} 
      height={size} 
      className={className}
      style={{ color: '#55B6A6' }}
    />
  );
};

export default Logo;
